import { createClient } from '@/shared/api';
import REJECT_RMA_TICKET_MUTATION from '../mutations/rejectRmaTicket';

/**
 * Rejects an RMA ticket by id. Runs the REJECT_RMA_TICKET_MUTATION and throws rejectRmaTicket.message when isSuccess is false.
 *
 * @param id - Identifier of the RMA ticket to reject.
 * @returns A promise resolving once the mutation result has been checked for success.
 */
const handleRejectRmaTicket = async (id: any) => {
  const client = createClient();
  const result = await client.mutate({
    mutation: REJECT_RMA_TICKET_MUTATION,
    variables: { id },
  });
  const { data } = result;
  const { rejectRmaTicket } = data;
  if (!rejectRmaTicket.isSuccess) {
    throw new Error(rejectRmaTicket.message);
  }
};

export default handleRejectRmaTicket;
